import { useEffect, useState } from 'react';

import config from '@/config';
import useQuery from '@/hooks/useQuery';
import Text from '@/shared-components/text/components/Text';

import VirtualList from './components/VirtualList.jsx';

import './index.css';

export default function HomeUsers({ valueFromSearch = "" }) {
  const [query, setQuery] = useState({ q: "", user_type: "collector", limit: 9 });
  const [searchLimited, setSearchLimited] = useState(false);
  const { loading, queryData, loadMoreData } = useQuery("search_users", `${config.apis.api.url}/search/${query.user_type}`, query, {
    injectToken: true
  });

  useEffect(() => {
    if(valueFromSearch.q) {
      const newQuery = { q: valueFromSearch.q, user_type: "collector" };
      setQuery(newQuery);
      setSearchLimited(false);
    } else {
      const newQuery = { q: "", user_type: "collector", limit: 9 };
      setQuery(newQuery);
      setSearchLimited(true);
    }
  }, [valueFromSearch.q]);

  return (
    <>     
      {
        !loading && (
          queryData.data.data.length === 0 ?
            <Text className="search-users-content__empty-text" paragraph medium>
              No users available for your search query.
            </Text>
            :
            <VirtualList 
              key={queryData.queryString} 
              items={queryData.data} 
              onLoadMore={loadMoreData}
              searchLimited={searchLimited}
            />
        )
      }
    </>
  );
}
